import React, { useState, useId } from 'react';
import {
  BlockStack,
  Card,
  Text,
  InlineStack,
  Button,
  ProgressBar,
  Box,
  Collapsible,
  Icon
} from '@shopify/polaris';
import { CheckIcon } from "@shopify/polaris-icons";
import SetupItem from './SetupItem';

const SetupGuide = ({ onStepComplete, items, isLoading, expanded, setExpanded, showToast, handleCompleteOnboarding, isOnboardingLoading }) => {
  const [isGuideOpen, setIsGuideOpen] = useState(true);
  const accessId = useId();
  const completedItemsLength = items.filter((item) => item.complete).length;

  return (
    <Card padding='0'>
      <Box padding='400' paddingBlockEnd='400'>
        <BlockStack>
          <InlineStack align='space-between' blockAlign='center'>
            <Text as="h3" variant="headingMd">
              👋 Welcome to Gold Price Sync ✨
            </Text>
          </InlineStack>
          <Text as='p' variant='bodyMd'>
            Learn about the key features of the app and how it helps automate your pricing process.
          </Text>
          <div style={{ marginTop: '.8rem' }}>
            <InlineStack blockAlign='center' gap='200'>
              {completedItemsLength === items.length ? (
                <div style={{ maxHeight: '1rem' }}>
                  <InlineStack wrap={false} gap='100'>
                    <Icon
                      source={CheckIcon}
                      tone='subdued'
                      accessibilityLabel="Check icon to indicate completion of App Overview"
                    />
                    <Text as='p' variant='bodySm' tone='subdued'>
                      Done
                    </Text>
                  </InlineStack>
                </div>
              ) : (
                <Text as='span' variant='bodySm'>
                  {`${completedItemsLength} / ${items.length} completed`}
                </Text>
              )}

              {completedItemsLength !== items.length ? (
                <div style={{ width: '100px' }}>
                  <ProgressBar
                    progress={(items.filter((item) => item.complete).length / items.length) * 100}
                    size='small'
                    tone='primary'
                    animated
                  />
                </div>
              ) : null}
            </InlineStack>
          </div>
        </BlockStack>
      </Box>
      <Collapsible open={isGuideOpen} id={accessId}>
        <Box padding='200'>
          <BlockStack gap='100'>
            {items.map((item) => {
              return (
                <SetupItem
                  key={item.id}
                  expanded={expanded === item.id}
                  setExpanded={() => setExpanded(item.id)}
                  onComplete={onStepComplete}
                  {...item}
                  isLoading={isLoading}
                  showToast={showToast}
                />
              );
            })}
          </BlockStack>
        </Box>
      </Collapsible>
      {completedItemsLength === items.length ? (
        <Box
          background='bg-surface-secondary'
          borderBlockStartWidth='025'
          borderColor='border-secondary'
          padding='300'
        >
          <InlineStack align='end'>
            <Button loading={isOnboardingLoading} onClick={() => handleCompleteOnboarding([], true)} variant='primary'>Get Started</Button>
          </InlineStack>
        </Box>
      ) : null}
    </Card>
  );
};

export default SetupGuide;
